import _styled from "@emotion/styled/base";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { css } from '@emotion/react';
import { rem, getResetByTag, utilityStyles } from '../../styles';
var defaultStyles = function defaultStyles(_ref) {
  var animation = _ref.animation,
    duration = _ref.duration;
  switch (animation) {
    case 'fade':
      return /*#__PURE__*/css("transition:opacity ", duration, "ms ease-in-out;opacity:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
    case 'slideRight':
    case 'slideBottom':
      return /*#__PURE__*/css("transition:transform ", duration, "ms ease-in-out,opacity ", duration, "ms ease-in-out;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
    case 'expand':
      return /*#__PURE__*/css("transition:height ", duration, "ms ease-in-out;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
  }
};
var renderHeight = function renderHeight(animationState, childHeight, containersize, isActive) {
  switch (animationState) {
    case 'entering':
      return /*#__PURE__*/css("height:", rem(childHeight), ";overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:renderHeight;"));
    case 'entered':
      return isActive ? /*#__PURE__*/css(process.env.NODE_ENV === "production" ? "" : ";label:renderHeight;") : /*#__PURE__*/css("height:", rem(containersize.height), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:renderHeight;"));
    default:
      return /*#__PURE__*/css("height:", rem(0), ";overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : ";label:renderHeight;"));
  }
};
var animationStateStyles = function animationStateStyles(_ref2) {
  var animation = _ref2.animation,
    animationState = _ref2.animationState,
    containersize = _ref2.containersize,
    childHeight = _ref2.childHeight,
    isActive = _ref2.isActive;
  // is visible if in 'entering' or 'entered' state
  var isVisible = ['entering', 'entered'].includes(animationState);
  // conditional 'opacity' and 'transform' styles
  var _ref3 = isVisible ? [1, 0] : [0, '100%'],
    _ref4 = _slicedToArray(_ref3, 2),
    opacity = _ref4[0],
    transform = _ref4[1];
  switch (animation) {
    case 'fade':
      return /*#__PURE__*/css("opacity:", opacity, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:animationStateStyles;"));
    case 'slideRight':
      return /*#__PURE__*/css("transform:translateX(", transform, ");opacity:", opacity, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:animationStateStyles;"));
    case 'slideBottom':
      return /*#__PURE__*/css("transform:translateY(", transform, ");opacity:", opacity, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:animationStateStyles;"));
    case 'expand':
      return renderHeight(animationState, childHeight, containersize, isActive);
  }
};
var resetStyles = getResetByTag('div');
var StyledAnimateComponent = function StyledAnimateComponent(Component) {
  return /*#__PURE__*/_styled(Component, process.env.NODE_ENV === "production" ? {
    target: "egb985i1"
  } : {
    target: "egb985i1",
    label: "StyledAnimateComponent"
  })(defaultStyles, animationStateStyles);
};
var StyledAnimate = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "egb985i0"
} : {
  target: "egb985i0",
  label: "StyledAnimate"
})(resetStyles, defaultStyles, animationStateStyles, utilityStyles);
export { StyledAnimate, StyledAnimateComponent };